import { render } from "./EventDialogContainer.vue?vue&type=template&id=22773d5c&ts=true"
import script from "./EventDialogContainer.vue?vue&type=script&lang=ts"
export * from "./EventDialogContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__